import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';
import { HumanQuestionRating } from '../../models/human-question-rating';

export const getHumanRatings: (
  fetchContext: FetchContext,
  awardId: number,
  nominationId: number,
  accessToken?: string,
) => Promise<HumanQuestionRating[]> = (fetchContext, awardId, nominationId, accessToken) =>
  fetch(`${fetchContext.baseUrl}/api/staff/awards/${awardId}/nominations/${nominationId}/human-ratings`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })
  .then((response) => responseErrorHandler<HumanQuestionRating[]>(fetchContext.errorStore, response, 'get human ratings'));
